import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import {
  AppSettingsNavService,
  NavSection,
} from '../../services/app-settings-nav.service';

@Component({
  selector: 'rk-app-settings-nav',
  imports: [TranslateModule, AsyncPipe],
  templateUrl: './app-settings-nav.component.html',
  styleUrl: './app-settings-nav.component.scss',
})
export class AppSettingsNavComponent implements OnInit, OnDestroy {
  activeSection$: Observable<NavSection>;
  private readonly subscriptions = new Subscription();

  constructor(private readonly navService: AppSettingsNavService) {}

  ngOnInit() {
    this.activeSection$ = this.navService.getActiveSection();
  }

  onNavItemClick(section: NavSection) {
    this.navService.scrollToSection(section);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
